module.exports = __webpack_public_path__ + "img/David_Fuchs.1c6c8ffa.png";